import { createClient } from "@supabase/supabase-js";

// This app is internal-only (no auth, per project decision) and reads
// directly from Supabase using the public anon key. The anon key is
// safe to expose client-side by design -- Supabase's security model
// puts access control in Row Level Security policies, not in keeping
// this key secret. Writes that need elevated privilege (recalculation,
// which touches offer_projections/scenario_partner_projections) go
// through the Python API instead, which uses the service-role secret
// key server-side, never sent to the browser.
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY must be set."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
